import {rowGutter} from '../../orgManager/Utils/OrgProfile/Forms/Constants/Common';

export {rowGutter};

export const PCF_COL_GUTTER_CLASS = 'gutter-row';

export const PCF_COL_SPAN_HALF = 12;

export const PCF_COL_SPAN_THIRD = 8;
